export const tailwindColorsPalette = {
    primary: {
        50: '#E6EEF7',
        100: '#CCDDEF',
        200: '#99BBDF',
        300: '#6699CF',
        400: '#3377BF',
        500: '#0055AF',
        600: '#004790',
        700: '#003D7A',
        800: '#003366',
        900: '#002952',
        950: '#001A33',
        DEFAULT: '#004790',
    },
    gold: {
        50: '#FDF8E9',
        100: '#FAF0D3',
        200: '#F5E1A7',
        300: '#F0D27B',
        400: '#E5BC55',
        500: '#D4A84B',
        600: '#B8923F',
        700: '#9A7A35',
        800: '#7C622A',
        900: '#5E4A20',
        950: '#403215',
        DEFAULT: '#D4A84B',
    },
    warning: {
        25: '#FFFCF5',
        50: '#FFFAEB',
        100: '#FEF0C7',
        200: '#FEDF89',
        300: '#FEC84B',
        400: '#FDB022',
        500: '#F79009',
        600: '#DC6803',
        700: '#B54708',
        800: '#93370D',
        900: '#7A2E0E',
        DEFAULT: '#F79009',
    },
    success: {
        25: '#F6FEF9',
        50: '#ECFDF3',
        100: '#D1FADF',
        200: '#A6F4C5',
        300: '#6CE9A6',
        400: '#32D583',
        500: '#12B76A',
        600: '#039855',
        700: '#027A48',
        800: '#05603A',
        900: '#054F31',
        DEFAULT: '#12B76A',
    },
    danger: {
        25: '#FFFBFA',
        50: '#FEF3F2',
        100: '#FEE4E2',
        200: '#FECDCA',
        300: '#FDA29B',
        400: '#F97066',
        500: '#F04438',
        600: '#D92D20',
        700: '#B42318',
        800: '#912018',
        900: '#7A271A',
        DEFAULT: '#F04438',
    },
    gray: {
        25: '#FAFAFA',
        50: '#F5F5F5',
        100: '#E9EAEB',
        200: '#D5D7DA',
        300: '#D0D5DD',
        400: '#667085',
        500: '#717680',
        600: '#535862',
        700: '#252B37',
        800: '#1D2939',
        900: '#181D27',
        950: '#0A0D12',
        DEFAULT: '#3F3F46',
    },
};
export const mantineColorsPalette = Object.entries(tailwindColorsPalette).reduce((acc, [key, colors]) => ({
    ...acc,
    [key]: Object.entries(colors)
        .filter(([k]) => k !== 'DEFAULT')
        .map(([, v]) => v),
}), {});
